/* eslint-disable import/prefer-default-export */
import { GET_YUSA_OVERNIGHT_CAMP_REPORT_DASHBOARD } from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getOvernightCampBranchDetails =
  branchNumber => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_REPORT_DASHBOARD(branchNumber),
      successAction: data => ({
        type: types.OVERNIGHT_CAMP_BRANCH_DETAILS_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.OVERNIGHT_CAMP_BRANCH_DETAILS_FAILURE,
        payload: error
      }),
      dispatch
    });
